import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { Observable, Subject } from 'rxjs';

@Injectable()
export class ProxyCommunicationService
  implements Resolve<ProxyCommunicationService>
{
  get inputs(): { [key: string]: any } {
    return this._inputs;
  }

  get inputsChange(): Observable<{ name: string; value: any }[]> {
    return this._inputsChange.asObservable();
  }

  private readonly _inputs: { [key: string]: any } = {};
  private readonly _inputsChange = new Subject<
    { name: string; value: any }[]
  >();
  constructor() {}

  resolve(): ProxyCommunicationService {
    return this;
  }

  setInputs(data: { name: string; value: any }[]): void {
    data.forEach((item) => {
      this._inputs[item.name] = item.value;
    });

    this._inputsChange.next(data);
  }
}
